// @flow

import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Row, Col, Button, FormGroup, Label, Badge, FormText } from 'reactstrap';

type Props = {
  entity: any,
  title: string,
  field: string,
  subField: string,
  trim: boolean,
  url: boolean,
  additionalField?: string,
};

const UrlOrString = (props: any) => {
  if (props.url) {
    const prefix = props.value.indexOf('/') === 0 ? '' : '/';
    const url = props.value.indexOf('http') === 0 ? props.value : `http://analysenliste.spital.sh${prefix}${props.value}`;
    return (
      <div>
        <a href={url} target="_blank">
          {props.label || props.value}
        </a>
      </div>
    );
  }
  return <Badge color="primary" style={{marginRight: 8}}>{props.value}</Badge>;
};

@observer
export default class TagList extends React.Component<Props, void> {
  @observable
  value: string = '';

  static defaultProps = {
    displayFields: ['name'],
    url: false,
  };

  render() {
    const { entity, field, title, additionalField, subField, url } = this.props;
    const values = entity[field];

    if (values && values.length > 0) {
      return (
        <React.Fragment>
          {values.map((v: string, i: number) => (
            <UrlOrString key={v} url={url} label={v[additionalField]} value={v[subField]} />
          ))}
        </React.Fragment>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Components/TagList.js